import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_COMS_BASE_URL, VERTICAL_NAMES } from "constants/constants";

const GET_OTP_ENDPOINT = "/api/get-gateway-otp";
const IL_GET_OTP_ENDPOINT = "/api/unified/get-gateway-otp";

export const getOtp = async ({ verticalName, ...payload }) => {
  const isIL = verticalName === VERTICAL_NAMES.IL;
  const endpoint = `${REACT_APP_COMS_BASE_URL}${
    isIL ? IL_GET_OTP_ENDPOINT : GET_OTP_ENDPOINT
  }`;

  const body = isIL
    ? { phone: payload.phone, isd_code: payload.isd_code }
    : payload;

  const options = {
    method: "POST",
    body,
  };

  return await fetchJSON(endpoint, options);
};

export const useGetOtp = () => {
  return useMutation({
    mutationFn: getOtp,
  });
};
